module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer pb-4",
    attrs: {
      "id": "footer"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-nav py-3",
    attrs: {
      "id": "footer-nav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 offset-lg-2 col-lg-2"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled nav-list pt-2"
  }, [_c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][9]"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][10]"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][11]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('ul', {
    staticClass: "list-unstyled nav-list pt-2"
  }, [_c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][12]"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][13]"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][14]"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][15]"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-external-link"
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][16]"
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][17]"
    }
  })], 1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-lg-2"
  }, [_c('p', {
    staticClass: "mb-0 nav-list-lang-head font-size-lg-06-down font-size-lg-06-up"
  }, [_c('b', {}, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][18]"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-language"
  })], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "list-disc-styled nav-list nav-list-lang border-top-0 pb-2"
  }, [_c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.setLnag('ja')
      }
    }
  }, [_vm._v("日本語")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.setLnag('en')
      }
    }
  }, [_vm._v("English")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-list-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.setLnag('zh-tw')
      }
    }
  }, [_vm._v("中文(繁體)")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-head"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "footer-logo-wrap offset-1 offset-lg-4 col-10 col-lg-4 py-1 px-5"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/photo_spot_international_footer_logo.png")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/daicolo_logo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 col-lg-2 text-left"
  }, [_c('div', [_c('img', {
    staticClass: "img-fluid w-50",
    attrs: {
      "src": require("assets/security_seal.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e26a753!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/GuestFooter.vue
// module id = 687
// module chunks = 0